import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import API from '../services/api';

export default function Horas() {
  const { usuario } = useAuth();
  const navigate = useNavigate();
  const [horas, setHoras] = useState([]);
  const [proyectos, setProyectos] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [tareas, setTareas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [modal, setModal] = useState(false);
  const [form, setForm] = useState({ empleado_id: '', proyecto_id: '', tarea_id: '', fecha: '', horas: '', notas: '' });
  const [error, setError] = useState('');
  const [filtroProyecto, setFiltroProyecto] = useState('');

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    try {
      const [pRes, eRes] = await Promise.all([
        API.get('/proyectos'),
        API.get('/empleados'),
      ]);
      setProyectos(pRes.data);
      setEmpleados(eRes.data);
      // Cargar horas de todos los proyectos
      const horasAll = [];
      for (const p of pRes.data) {
        try {
          const hRes = await API.get(`/horas/proyecto/${p.id}`);
          if (hRes.data?.todas) {
            hRes.data.todas.forEach(h => horasAll.push({...h, proyecto_id: h.proyecto_id || p.id, proyecto_nombre: p.nombre}));
          }
        } catch(e) {}
      }
      setHoras(horasAll);
    } catch(e) {}
    setCargando(false);
  };

  const cargarTareas = async (proyectoId) => {
    if (!proyectoId) { setTareas([]); return; }
    try {
      const res = await API.get(`/proyectos/${proyectoId}/tareas`);
      setTareas(res.data || []);
    } catch(e) { setTareas([]); }
  };

  const abrirNuevo = (proyectoIdInicial = '') => {
    const hoy = new Date().toISOString().split('T')[0];
    setForm({ empleado_id: '', proyecto_id: proyectoIdInicial, tarea_id: '', fecha: hoy, horas: '', notas: '' });
    if (proyectoIdInicial) cargarTareas(proyectoIdInicial);
    setError('');
    setModal(true);
  };

  const guardar = async () => {
    setError('');
    if (!form.proyecto_id || !form.fecha || !form.horas) { setError('Proyecto, fecha y horas son obligatorios'); return; }
    try {
      const payload = {
        proyecto_id: parseInt(form.proyecto_id),
        tarea_id: form.tarea_id ? parseInt(form.tarea_id) : null,
        fecha: form.fecha + 'T00:00:00',
        horas: parseFloat(form.horas),
        notas: form.notas || null,
        empleado_id: form.empleado_id ? parseInt(form.empleado_id) : null,
      };
      await API.post('/horas', payload);
      setModal(false);
      cargar();
    } catch(e) { setError(e.response?.data?.detail || 'Error al guardar'); }
  };

  const fmtFecha = (iso) => iso ? new Date(iso).toLocaleDateString('es-ES', {day:'2-digit',month:'2-digit',year:'numeric'}) : '—';
  const nombreEmpleado = (id) => empleados.find(e => e.id === id)?.nombre || '—';

  const horasFiltradas = filtroProyecto ? horas.filter(h => h.proyecto_id === parseInt(filtroProyecto)) : horas;
  const totalHoras = horasFiltradas.reduce((acc, h) => acc + (parseFloat(h.horas) || 0), 0);

  if (cargando) return <div style={s.loading}>Cargando...</div>;

  return (
    <div style={s.page}>
      <div style={s.topbar}>
        <div style={s.topbarTitle}>Horas imputadas</div>
        <div style={s.topbarActions}>
          <select style={s.select} value={filtroProyecto} onChange={e => setFiltroProyecto(e.target.value)}>
            <option value="">Todos los proyectos</option>
            {proyectos.map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
          </select>
          <button style={s.btn} onClick={() => abrirNuevo()}>+ Imputar horas</button>
        </div>
      </div>

      <div style={s.content}>
        <div style={s.resumen}>
          <div style={s.resumenItem}><span style={s.resumenNum}>{horasFiltradas.length}</span><span style={s.resumenLabel}>Imputaciones</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{totalHoras.toFixed(1)}h</span><span style={s.resumenLabel}>Horas totales</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{[...new Set(horasFiltradas.map(h=>h.empleado_id))].length}</span><span style={s.resumenLabel}>Empleados</span></div>
          <div style={s.resumenItem}><span style={s.resumenNum}>{[...new Set(horasFiltradas.map(h=>h.proyecto_id))].length}</span><span style={s.resumenLabel}>Proyectos</span></div>
        </div>

        {horasFiltradas.length === 0 ? (
          <div style={s.empty}><div style={s.emptyText}>No hay horas imputadas</div></div>
        ) : (
          <div style={s.card}>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Empleado</th>
                  <th style={s.th}>Proyecto</th>
                  <th style={s.th}>Fecha</th>
                  <th style={s.th}>Horas</th>
                  <th style={s.th}>Notas</th>
                </tr>
              </thead>
              <tbody>
                {horasFiltradas.map((h, i) => (
                  <tr key={i} style={{...s.tr, cursor:'pointer'}} onClick={() => navigate(`/horas/${h.id}`)}>
                    <td style={s.td}><span style={s.empNombre}>{nombreEmpleado(h.empleado_id)}</span></td>
                    <td style={s.td}><span style={s.muted}>{h.proyecto_nombre}</span></td>
                    <td style={s.td}><span style={s.muted}>{fmtFecha(h.fecha)}</span></td>
                    <td style={s.td}><span style={{fontWeight:600,color:'#378ADD'}}>{h.horas}h</span></td>
                    <td style={s.td}><span style={s.muted}>{h.notas || '—'}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <div style={s.overlay} onClick={() => setModal(false)}>
          <div style={s.modal} onClick={e => e.stopPropagation()}>
            <div style={s.modalHeader}>
              <div style={s.modalTitle}>Imputar horas</div>
              <button style={s.closeBtn} onClick={() => setModal(false)}>✕</button>
            </div>
            {error && <div style={s.errorBox}>{error}</div>}
            <div style={s.field}>
              <label style={s.label}>Empleado</label>
              <select style={s.input} value={form.empleado_id} onChange={e => setForm({...form, empleado_id: e.target.value})}>
                <option value="">Selecciona empleado</option>
                {empleados.filter(e=>e.activo).map(e => <option key={e.id} value={e.id}>{e.nombre}</option>)}
              </select>
            </div>
            <div style={s.field}>
              <label style={s.label}>Proyecto *</label>
              <select style={s.input} value={form.proyecto_id} onChange={e => { setForm({...form, proyecto_id: e.target.value, tarea_id: ''}); cargarTareas(e.target.value); }}>
                <option value="">Selecciona proyecto</option>
                {proyectos.filter(p=>p.estado==='activo').map(p => <option key={p.id} value={p.id}>{p.nombre}</option>)}
              </select>
            </div>
            {tareas.length > 0 && (
              <div style={s.field}>
                <label style={s.label}>Tarea (opcional)</label>
                <select style={s.input} value={form.tarea_id} onChange={e => setForm({...form, tarea_id: e.target.value})}>
                  <option value="">Sin tarea específica</option>
                  {tareas.map(t => <option key={t.id} value={t.id}>{t.nombre}</option>)}
                </select>
              </div>
            )}
            <div style={s.fieldRow}>
              <div style={{...s.field,flex:1}}>
                <label style={s.label}>Fecha *</label>
                <input style={s.input} type="date" value={form.fecha} onChange={e => setForm({...form, fecha: e.target.value})} />
              </div>
              <div style={{...s.field,flex:1}}>
                <label style={s.label}>Horas *</label>
                <input style={s.input} type="number" step="0.5" min="0.5" value={form.horas} onChange={e => setForm({...form, horas: e.target.value})} placeholder="2.5" />
              </div>
            </div>
            <div style={s.field}>
              <label style={s.label}>Notas</label>
              <input style={s.input} value={form.notas} onChange={e => setForm({...form, notas: e.target.value})} placeholder="Descripción del trabajo realizado" />
            </div>
            <div style={s.modalFooter}>
              <button style={s.btnSecondary} onClick={() => setModal(false)}>Cancelar</button>
              <button style={s.btn} onClick={guardar}>Guardar horas</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page: { display:'flex', flexDirection:'column', minHeight:'100vh', background:'#f5f5f3', fontFamily:'-apple-system, BlinkMacSystemFont, Inter, sans-serif' },
  loading: { display:'flex', alignItems:'center', justifyContent:'center', height:'100vh', color:'#aaa', fontSize:14 },
  topbar: { background:'white', borderBottom:'0.5px solid #e0e0d8', padding:'0 24px', height:48, display:'flex', alignItems:'center', justifyContent:'space-between' },
  topbarTitle: { fontSize:14, fontWeight:500, color:'#1a1a1a' },
  topbarActions: { display:'flex', gap:10, alignItems:'center' },
  content: { padding:24, display:'flex', flexDirection:'column', gap:16 },
  resumen: { display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:12 },
  resumenItem: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:10, padding:'12px 16px', display:'flex', flexDirection:'column', gap:2 },
  resumenNum: { fontSize:22, fontWeight:600, color:'#1a1a1a' },
  resumenLabel: { fontSize:11, color:'#aaa', textTransform:'uppercase', letterSpacing:'0.05em' },
  card: { background:'white', border:'0.5px solid #e0e0d8', borderRadius:12, overflow:'hidden' },
  table: { width:'100%', borderCollapse:'collapse' },
  th: { padding:'10px 16px', fontSize:11, fontWeight:500, color:'#aaa', textAlign:'left', borderBottom:'0.5px solid #f0f0ed', textTransform:'uppercase', letterSpacing:'0.05em' },
  tr: { borderBottom:'0.5px solid #f0f0ed' },
  td: { padding:'12px 16px', fontSize:13, color:'#1a1a1a', verticalAlign:'middle' },
  empNombre: { fontWeight:500 },
  muted: { color:'#888' },
  btn: { background:'#378ADD', color:'white', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:500, cursor:'pointer' },
  btnSecondary: { background:'white', color:'#666', border:'0.5px solid #d0d0c8', borderRadius:8, padding:'8px 14px', fontSize:13, cursor:'pointer' },
  select: { padding:'7px 10px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:13, background:'white', outline:'none' },
  empty: { textAlign:'center', padding:'64px 0' },
  emptyText: { fontSize:14, color:'#aaa' },
  overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.3)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000 },
  modal: { background:'white', borderRadius:12, border:'0.5px solid #e0e0d8', padding:24, width:'100%', maxWidth:440, maxHeight:'90vh', overflowY:'auto' },
  modalHeader: { display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 },
  modalTitle: { fontSize:15, fontWeight:500, color:'#1a1a1a' },
  closeBtn: { background:'none', border:'none', fontSize:16, cursor:'pointer', color:'#aaa' },
  errorBox: { background:'#FCEBEB', color:'#A32D2D', borderRadius:8, padding:'10px 14px', fontSize:13, marginBottom:16 },
  field: { marginBottom:16 },
  fieldRow: { display:'flex', gap:12 },
  label: { display:'block', fontSize:13, color:'#444', marginBottom:6, fontWeight:500 },
  input: { width:'100%', padding:'9px 12px', borderRadius:8, border:'0.5px solid #d0d0c8', fontSize:14, outline:'none', boxSizing:'border-box', background:'white' },
  modalFooter: { display:'flex', justifyContent:'flex-end', gap:10, marginTop:24 },
};
